/* eslint-disable no-nested-ternary */
import classNames from 'classnames';

import styled from 'styled-components';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { DOWN_PRICE, UP_PRICE } from 'Utils/Constants';
import {
  boxShadow, primaryFont, secondaryFont, wMBold, wMedium,
  maxWidth, retina, highPriceStat, lowPriceStat, maxWidth1300, minWidthApp, maxTablet, maxMobile,
} from '../../../Utils/utilsStyle';

type Props = {
  companyName: string,
  state: string,
  title?: string,
  colorText?: string,
  sizeText?: string,
  sizeTextSm?: string,
  titleClassName?: string,
  statClassName?: string,
  labelClassName?: string,
  personDetail?: boolean,
  paddingSm?: string,
  sign?: string,
  currency?: string,
  currencySymbol?: string,
  spotlightFlag?: boolean,
} & typeof defaultProps;

const defaultProps = {
  title: '',
  colorText: '#001823',
  sizeText: '30px',
  sizeTextSm: '24px',
  paddingSm: '8px 0',
  titleClassName: '',
  statClassName: '',
  labelClassName: '',
  sign: '',
  personDetail: false,
  currency: '',
  currencySymbol: '',
  spotlightFlag: false,
};

const Wrapper = styled.div< { spotlightFlag: boolean, colorText: string, sizeText: string, sizeTextSm: string, paddingSm: string, image: string, } >`
  background-image: url(${(props) => (props.image)});
  background-position: center;
  background-size: 100% 50%;
  background-repeat: no-repeat;
  min-height: ${(props) => (props.spotlightFlag ? '100px' : '112px')};
  width:100%;
  box-shadow: ${boxShadow};
  border-radius: 8px;
  text-align:center;
  padding: 12px 0px;
  margin-bottom: 20px;
  &.downPrice {
    background-size: 100% 100%;
  }
  &.withoutState {
     /* will add class */

  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
    border-radius: 6px;
    margin-bottom: 10px;
    min-height: 84px;
    padding: ${(props) => props.paddingSm};
  }
  &.personDetailWidget {
    background: #FFFFFF;
    margin-bottom: 0;
    .state {
      color: #E79540;
      font-family: ${secondaryFont};
      font-weight: ${wMedium};
      font-size: 28px;
      margin: 7px;
      letter-spacing: -0.7px;
      @media all and (max-width: ${maxMobile}) {
       font-size: 16px;
      }
    }
    .companyName {      
      color: #67696A;
      font-family: ${primaryFont};
      font-weight: ${wMBold};
      font-size: 16px;
      letter-spacing: -0.33px;
      /* line-height: 34px; */
      margin-bottom:7px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 9px;
      }
      @media all and (max-width: ${maxTablet}) {
       margin-bottom: 0px;
      }
    }
  }
  span {
    display:block;
  }
  .title {
    color: ${(props) => props.colorText};
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 10px;
    line-height: 12px;
    margin-bottom:7px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 9px;
    }
    @media all and (max-width: ${maxTablet}) {
      margin-bottom: 0px;
    }
  }
  .companyName{
    color: #001823;
    font-family: ${secondaryFont};
    font-weight: ${wMBold};
    font-size: 14px;
    line-height: 16px;
    margin: 10px;
    margin-bottom: 0px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 9px;
      line-height: 11px;
      margin: 5px;
      margin-bottom: 0px;
    }
    @media all and (max-width: ${minWidthApp}) {
      font-size: 8px;
    }
  }
  .currency {
    color: #001823;
    text-align: center;
    font-family: ${secondaryFont};
    font-size: 12px;
    font-weight: ${wMedium};
    line-height: 14.655px;
    letter-spacing: -0.3px;
    min-height: 15px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 10px;
    }
  }
  .state{
    color: ${(props) => props.colorText};
    position: relative;
    font-family: ${secondaryFont};
    font-weight: ${wMBold};
    font-size: ${(props) => props.sizeText};
    line-height: 32px;
    margin: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      line-height: 24px;
      margin: 8px;
      font-size:${(props) => props.sizeTextSm};
    }

    @media all and (max-width: ${maxWidth1300}){
      font-size: 20px;
    }

    @media all and (max-width: ${minWidthApp}){
      font-size: 14px;
    }
    
    .sign{
      font-size: 18px;
      margin-right: 2px;
       @media all and (max-width: ${minWidthApp}){
      font-size: 14px;
     }
    }
  }
`;

const StatesWidgetPrimary = function StatesWidgetPrimary(props: Props) {
  const {
    companyName, state, title, colorText, sizeText, sizeTextSm,
    titleClassName, currency, currencySymbol,
    statClassName,
    labelClassName,
    personDetail,
    paddingSm,
    sign,
    spotlightFlag,
  } = props;

  const image = title === 'Share Price' ? sign === UP_PRICE ? highPriceStat : lowPriceStat : '';

  return (
    <Wrapper
      colorText={colorText}
      sizeText={sizeText}
      sizeTextSm={sizeTextSm}
      paddingSm={paddingSm}
      spotlightFlag={spotlightFlag}
      className={classNames(
        'states-widget-primary',
        {
          personDetailWidget: personDetail,
          upPrice: sign === UP_PRICE,
          downPrice: sign === DOWN_PRICE,
          withoutState: !currency && !currencySymbol,
        },
      )}
      image={image}
    >

      <span className="currency">
        {currency && currencySymbol ? (
          <>
            {currency && currency}
            {' '}
            {currencySymbol && currencySymbol}
          </>
        ) : null}
      </span>
      <span className={`state ${statClassName || ''}`}>
        {title === 'Share Price'
          ? (
            <span className="sign">
              {sign === UP_PRICE ? <CaretUpOutlined /> : <CaretDownOutlined />}
            </span>
          )
          : null}
        {Array(state).join('').replace(/NT/g, ' ')}
      </span>
      {title ? (
        <span className={`title ${titleClassName || ''}`}>
          {title}
        </span>
      ) : null}
      <span className={`companyName text-truncate ${labelClassName || ''}`}>{companyName}</span>
    </Wrapper>
  );
};

StatesWidgetPrimary.defaultProps = defaultProps;

export default StatesWidgetPrimary;
